// extracted by mini-css-extract-plugin
export default {"statDisk":"Pie_statDisk__n+KWt","containerDisk":"Pie_containerDisk__R22Ys"};